module.exports = __webpack_public_path__ + "img/img_services_equipment.b327ddcf.jpg";